import { DUPE_API_URL } from '@dupe/common/constants'
import fetcher from '~/src/lib/fetcher'
import logger from '~/src/lib/logger'

export interface UploadImageResponse {
  imageUrl: string
  hash: string
  fileId: string
  parsedData?: {
    category: string
    description: string
  }
}

/**
 * Upload image using the new API endpoint
 * Consolidates upload and hash generation in a single call
 * Optionally processes image with AI vision for category and description extraction
 */
export const uploadImageViaAPI = async (
  fileData: string,
  options: {
    enableVisionProcessing?: boolean
    authUser?: any
  } = {}
): Promise<UploadImageResponse> => {
  const { enableVisionProcessing = false, authUser } = options

  try {
    logger.debug('🖼️ Upload Image API - Starting upload', {
      fileDataLength: fileData.length,
      enableVisionProcessing,
    })

    const response = await fetcher<UploadImageResponse>(
      `${DUPE_API_URL}/api/upload-image`,
      {
        method: 'POST',
        authUser,
        dataOrParams: {
          fileData,
          enableVisionProcessing,
        },
      }
    )

    if (!response.imageUrl || !response.hash) {
      throw new Error('Invalid response from upload API')
    }

    logger.debug('✅ Upload Image API - Success', {
      imageUrl: response.imageUrl,
      hash: response.hash,
    })

    return response
  } catch (error: any) {
    logger.error('🚨 Upload Image API - Error', {
      error: error.message,
      fileDataLength: fileData.length,
      enableVisionProcessing,
    })
    throw error
  }
}
